<div class="mbs-onboarding-notification-step">
  <mbs-card customClasses="bg-gray-10 h-auto"
            [size]="'sm'"
            [hasPadding]="false"
            [formGroup]="notificationsForm">
    <h4 class="font-weight-bold border-bottom border-2 d-flex align-items-center justify-content-between p-3 mb-0">
      {{ 'wizards:onboarding.notifications.title' | i18next : { format: 'title' } }}

      <mbs-switcher formControlName="SendNotification"></mbs-switcher>
    </h4>

    <div *ngIf="onlyOnFailureControl"
         class="border-bottom border-2 p-3">
      <mbs-form-group class="mb-0"
                      [title]="'wizards:onboarding.notifications.labelRadio' | i18next"
                      [titleClasses]="notificationsForm?.get('SendNotification').value ? 'mb-2 font-weight-bold' : 'mb-2 font-weight-bold -disabled'"
                      [contentCustomClass]="'d-flex align-items-center'">
        <mbs-radio formControlName="OnlyOnFailure"
                   name="groupBy"
                   [label]="'wizards:onboarding.notifications.notFailureOnlyLabel' | i18next"
                   [id]="'groupBy2'"
                   [value]="false"></mbs-radio>
        <mbs-radio formControlName="OnlyOnFailure"
                   name="groupBy"
                   class="ml-3 mt-0"
                   [label]="'wizards:onboarding.notifications.failureOnlyLabel' | i18next"
                   [id]="'groupBy1'"
                   [value]="true"></mbs-radio>
      </mbs-form-group>
    </div>

    <div class="p-3 w-50">
      <mbs-input [label]="'wizards:onboarding.notifications.notificationsRecipient' | i18next"
                 [boldLabel]="true"
                 [showRequiredMark]="false"
                 [validationWhitespace]="true"
                 formControlName="Email"></mbs-input>
    </div>
  </mbs-card>
</div>
